export default (theme) => ({
  scoresContainer: {
    padding: '10px 20px',
    width: '100%',
  },
  scoreProgressArea: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0px',
  },
  progressLabelsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 10,
  },
  progressLabel: {
    ...theme.typography.t14,
    fontWeight: 700,
    textTransform: 'capitalize',
    padding: '0px 20px 0px 0',
  },
  progressBarRoot: {
    height: 10,
    borderRadius: 5,
    backgroundColor: 'white',
  },
  headerText: {
    fontWeight: 500,
    fontSize: '26px',
    padding: '0px 20px',
    marginBottom: '12px',
    marginTop: '30px',

  }
});
